import dayjs from 'dayjs';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';

const getTimezoneOffset = (): number => {
  return new Date().getTimezoneOffset();
};

export const getWeeklyData = async (
  startDate: number,
  endDate: number,
  timezoneOffset?: number
) => {
  try {
    const data = await fetcher.post(
      API_ENDPOINTS.TASK.GET_TASK_TIMELINE,
      {
        type: 'weekly',
        startTime: startDate,
        endTime: endDate,
        timezoneOffset: timezoneOffset || getTimezoneOffset(),
      },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return data.data;
  } catch (error: any) {
    throw error;
  }
};

export const getDataForWeeklyCompliance = async () => {
  try {
  } catch (error) {}
};

export const getTaskCount = async () => {
  const date = dayjs();
  const startTime = date.startOf('day').valueOf();
  const endTime = date.endOf('day').valueOf();
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.TASK.GET_TASK_COUNT,
      {
        startTime,
        endTime,
      },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return data.data.count;
  } catch (error: any) {
    throw error;
  }
};

export const getMonthlyData = async (
  startDate: number,
  endDate: number,
  timezoneOffset?: number
) => {
  try {
    const data = await fetcher.post(
      API_ENDPOINTS.TASK.GET_TASK_TIMELINE,
      {
        type: 'monthly',
        startTime: startDate,
        endTime: endDate,
        timezoneOffset: timezoneOffset || getTimezoneOffset(),
      },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return data.data;
  } catch (error: any) {
    throw error;
  }
};

export const getAllInspectionDetails = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.INSPECTION.GET_INSPECTION_DETAIL,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadAllInspectionDetails = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.INSPECTION.DOWNLOAD_INSPECTION_DETAIL,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadAllPriceRecords = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.PRICE.DOWNLOAD_PRICE_RECORDS,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAllInspectionDetailsById = async (inspectionId: any) => {
  try {
    const response = await fetcher.get(
      `${API_ENDPOINTS.INSPECTION.GET_INSPECTION}/${inspectionId}`,
      {},
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getTaskTypeOptions = async () => {
  try {
    const response = await fetcher.get(
      `${API_ENDPOINTS.TASK.GET_TASK_TYPES}`,
      {},
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    /* const response = [
      {
        "key": "LEGAL_METROLOGY_INSPECTION",
        "id" : "1"
      },
      {
        "key": "CONSUMER_PRICE_INSPECTION",
        "id" : "2"
      },
    ] */

    return response?.data?.data;
  } catch (error: any) {
    throw error;
  }
};

export const getLegalMetroTypeOptions = async (id: any) => {
  try {
    let url = API_ENDPOINTS.TASK.GET_LEGAL_METRO_TASK_TYPES.replace(':id', id);
    const response = await fetcher.get(url, {}, {}, ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE);

    /* const response = [
      {
        "key": "SCALE_FORMAT_VERIFICATION",
        "taskTypeId" : "1"
      },
      {
        "key": "PRE_PACKAGED_PRODUCT_VERIFICATION",
        "taskTypeId" : "2"
      },
      {
        "key": "FUEL_DISPENSER_VERIFICATION",
        "taskTypeId" : "3"
      }
    ] */

    // return response;
    return response?.data?.data;
  } catch (error: any) {
    throw error;
  }
};

export const getDynamicTaskFields = async (id: any) => {
  try {
    let url = API_ENDPOINTS.TASK.GET_DYNAMIC_FIELDS.replace(':id', id);
    const response = await fetcher.get(url, {}, {}, ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE);

    /* let response;
    if(id=== 1){
      response = [
        {
            "name": "assignee",
            "type": "select",
            "label": "Assignee",
            "placeholder": "Assignee",
            "options": "assigneeOptions",
            "mode":"multiple",
            "showSearch"  : true,
            "allowClear": true,
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "assigneeFieldRequired"
                }
            }
        },
        {
            "name": "priority",
            "type": "select",
            "label": "Priority",
            "placeholder": "Priority",
            "options": "priorityOptions",
            "allowClear": true,
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "priorityFieldRequired"
                }
            }
        },
        {
            "name": "department",
            "type": "select",
            "label": "Department",
            "placeholder": "Department",
            "options": "departmentsOptions",
            "showSearch"  : true,
            "allowClear": true,
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "departmentFieldRequired"
                }
            }
        },
        {
            "name": "municipality",
            "type": "select",
            "label": "Municipality",
            "placeholder": "Municipality",
            "options": "municipalityOptions",
            "showSearch"  : true,
            "allowClear": true,
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "municipalityFieldRequired"
                }
            }
        },
        {
            "name": "typeOfEstablishment",
            "type": "select",
            "label": "Type of Establishment",
            "placeholder": "Type of Establishment",
            "options": "typeOfPositionOptions",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "typeOfPositionFieldRequired"
                }
            }
        },
        {
            "name": "establishment",
            "type": "select",
            "label": "Establishment",
            "placeholder": "Establishment",
            "options": "establismentOptions",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "establishmentFieldRequired"
                }
            }
        },
        {
            "name": "dueDate",
            "type": "date",
            "label": "Due Date",
            "placeholder": "Due Date",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "dueDateFieldRequired"
                }
            }
        },
        {
            "name": "isTaskRepeated",
            "type": "checkbox",
            "label": "Repeat this task",
            "placeholder": "Repeat this task",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "repeatTaskRequired"
                }
            }
        },
        {
            "name": "description",
            "type": "textArea",
            "label": "Description",
            "placeholder": "Description",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "descriptionRequired"
                },
                "noOnlySpaces": {
                    "value": true,
                    "messageKey": "descriptionSpaceValidation"
                },
                "maxLengthTrimmed": {
                    "value": 1000,
                    "messageKey": "descriptionMaxValidation"
                },
                "minLengthTrimmed": {
                    "value": 5,
                    "messageKey": "descriptionMinValidation"
                }
            }
        }
    ]
    }
    else if(id === 2)
    {
      [
        {
            "type": "select",
            "name": "assignee",
            "label": "Assignee",
            "placeholder": "Assignee",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "assigneeFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "priority",
            "label": "Priority",
            "placeholder": "Priority",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "priorityFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "department",
            "label": "Department",
            "placeholder": "Department",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "departmentFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "municipality",
            "label": "Municipality",
            "placeholder": "Municipality",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "municipalityFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "typeOfEstablishment",
            "label": "Type of Establishment",
            "placeholder": "Type of Establishment",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "typeOfPositionFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "establishment",
            "label": "Establishment",
            "placeholder": "Establishment",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "establishmentFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "product",
            "label": "Product",
            "placeholder": "Product",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "productFieldRequired"
                },
              }
        },
        {
            "type": "date",
            "name": "dueDate",
            "label": "Due Date",
            "placeholder": "Due Date",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "dueDateFieldRequired"
                },
              }
        },
        {
            "type": "checkbox",
            "name": "isTaskRepeated",
            "label": "Repeat this task",
            "placeholder": "Repeat this task",
            "validations": {
                "required": {
                    "value": false,
                    "messageKey": "repeatTaskRequired"
                },
              }
        },
        {
            "type": "textArea",
            "name": "description",
            "label": "Description",
            "placeholder": "Description",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "descriptionRequired"
                },
                "noOnlySpaces": {
                    "value": true,
                    "messageKey": "descriptionSpaceValidation"
                },
                "minLengthTrimmed": {
                    "value": 5,
                    "messageKey": "descriptionMinValidation"
                },
                "maxLengthTrimmed": {
                    "value": 1000,
                    "messageKey": "descriptionMaxValidation"
                }
            }
        }
    ]
    }
    else {
      [
        {
            "type": "select",
            "name": "assignee",
            "label": "Assignee",
            "placeholder": "Assignee",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "assigneeFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "priority",
            "label": "Priority",
            "placeholder": "Priority",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "priorityFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "department",
            "label": "Department",
            "placeholder": "Department",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "departmentFieldRequired"
                },
              }
        },
        {
            "type": "select",
            "name": "municipality",
            "label": "Municipality",
            "placeholder": "Municipality",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "municipalityFieldRequired"
                },
              }
        },
        {
            "type": "text",
            "name": "fuelStationName",
            "label": "Fuel Station Name",
            "placeholder": "Fuel Station Name",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "fuelStationNameRequired"
                },
                "noOnlySpaces": {
                    "value": true,
                    "messageKey": "fuelStationNameSpaceValidation"
                },
                "minLengthTrimmed": {
                    "value": 3,
                    "messageKey": "fuelStationNameMinValidation"
                },
                "maxLengthTrimmed": {
                    "value": 80,
                    "messageKey": "fuelStationNameMaxValidation"
                },
                "pattern": {
                  "value": "^[A-Za-zÁÉÍÓÚáéíóúÑñÜü0-9 ,\\-\\/\.\\(\\)]*$",
                  "messageKey": "invalidFuelStationName"
                }
            }
        },
        {
            "type": "date",
            "name": "dueDate",
            "label": "Due Date",
            "placeholder": "Due Date",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "dueDateFieldRequired"
                },
              }
        },
        {
            "type": "checkbox",
            "name": "isTaskRepeated",
            "label": "Repeat this task",
            "placeholder": "Repeat this task",
            "validations": {
                "required": {
                    "value": false,
                    "messageKey": ""
                },
              }
        },
        {
            "type": "textArea",
            "name": "description",
            "label": "Description",
            "placeholder": "Description",
            "validations": {
                "required": {
                    "value": true,
                    "messageKey": "descriptionRequired"
                },
                "noOnlySpaces": {
                    "value": true,
                    "messageKey": "descriptionSpaceValidation"
                },
                "minLengthTrimmed": {
                    "value": 5,
                    "messageKey": "descriptionMinValidation"
                },
                "maxLengthTrimmed": {
                    "value": 1000,
                    "messageKey": "descriptionMaxValidation"
                }
            }
        }
    ]
    } */

    return response?.data?.data;
    // return response;
  } catch (error: any) {
    throw error;
  }
};
